export default __webpack_public_path__ + "static/media/1065.02e4fec5.png";